import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../dialogFooter'

import FornecedoresTable from '../fornecedores/fornecedoresTable'

import GrupoDePagamentoTable from './grupoDePagamentoTable'
import { Button } from 'primereact/button'
import EditOrCreateGrupoDePagamentoDialog from './editOrCreateGrupoDePagamentoDialog'
import ConstantsUtil from '../../context/constantsUtil'
import GeneralServices from '../../app/service/generalServices'

class ChooseGrupoDePagamentoDialog extends React.Component {

    state = {

        selectedGrupoDePagamento: '',
        grupoDePagamentoList: [],
        filteredGrupoDePagamentoList: [],

        searchText: '',

        cadastrarGrupoDialogVisible: false,

        didUpdated: false,

    }

    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){
        this.setState({searchText: ''})
        this.setState({grupoDePagamentoList: this.props.list})
        this.setState({filteredGrupoDePagamentoList: this.props.list})

        if(this.props.doneForceUpdate){
            this.props.doneForceUpdate()
        }
            
        this.setState({didUpdated: true})
        }
    }

    handleChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
        this.filter()
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            const filteredList = JSON.parse(JSON.stringify(this.state.filteredGrupoDePagamentoList))
            if(filteredList.length === 1){
                await this.setState({selectedGrupoDePagamento: filteredList[0]})
                this.callSave()
            }
          }
    }

    handleSelectionGrupoDePagamentoChange = (value) => {
        if(value === null){ //significa que clicou em cima do Grupo De Pagamento que estava selecionado antes (double click)
            this.callSave()
        } else{
            this.setState({selectedGrupoDePagamento: value})
        }
    }

    hideDialog = () => {
        this.setState({didUpdated: false})
        this.props.hideDialog()
    }

    hideCadastrarGrupoDialog = () => {
        this.setState({cadastrarGrupoDialogVisible: false})
    }

    callSave = async () => {
        await this.props.handleSelectionGrupoDePagamentoChange(this.state.selectedGrupoDePagamento)
        this.hideDialog()
    }

    cadastrarGrupo = () => {
        this.setState({cadastrarGrupoDialogVisible: true})
    }

    filter  = () => {
        
        this.setState({
            filteredGrupoDePagamentoList:
                JSON.parse(
                    JSON.stringify(
                        this.state.grupoDePagamentoList.filter(grupoDePagamento => {
                            return (
                                GeneralServices.includeString(grupoDePagamento.nome, this.state.searchText)
                                // grupoDePagamento.nome.toLowerCase().includes(this.state.searchText.toLowerCase())
                            )
                        }
                        )
                    )
                )
        })
    }

    render () {

        const chooseGrupoDePagamentoDialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.props.disabled}/>
        )

        return (
            <>
            <Dialog 
                    visible={this.props.visible}
                    style={{ width: '70vw' }}
                    header={this.props.header}
                    modal
                    className="p-fluid"
                    footer={chooseGrupoDePagamentoDialogFooter}
                    onHide={this.hideDialog}
            >

                <div className="p-field">
                    <label htmlFor="searchGrupo">Busca</label>
                    <input style={{color: '#000'}}
                        autoFocus  
                        className={"form-control " }
                        type="text"
                        id="searchText"
                        name="searchText"
                        value={this.state.searchText}
                        placeholder="Pesquise pelo nome"
                        onChange = {this.handleChange}
                        onKeyPress={this.handleKeyPress}
                    />
                </div>

                <br />

                {/* <div className = "col-md-4"> */}
                <Button
                    label="Cadastrar"
                    icon="pi pi-plus"
                    onClick = {this.cadastrarGrupo}
                    style={ {maxWidth: '200px' } }
                />
                {/* </div> */}

                <br />
                
                <br />

                <GrupoDePagamentoTable
                    list = {this.state.filteredGrupoDePagamentoList}
                    searchText={this.state.searchText}
                    search={this.search}
                    selectable
                    handleSelectionGrupoDePagamentoChange={this.handleSelectionGrupoDePagamentoChange}
                    push={this.props.push}
                    loading = {this.props.loading}
                />

                <EditOrCreateGrupoDePagamentoDialog 
                    header="Cadastrar Grupo De Pagamento"
                    hideDialog={this.hideCadastrarGrupoDialog}
                    visible={this.state.cadastrarGrupoDialogVisible}
                    dialogType={ConstantsUtil.tipoDialogGrupoDePagamentoCreateLabel}
                    // state={this.state.gruporDePagamentoToEdit}
                    search={this.props.search}
                    push={this.props.push}
                />


            </Dialog>
            </>
        )
    }


}

export default ChooseGrupoDePagamentoDialog